/**
 * Het venster met de teksten die de leerling al gelezen heeft, elk met de
 * score van de meerkeuzevragen en een knop om hem terug te kijken.
 */
import React from 'react';
import { Eye } from 'lucide-react';
import { Venster } from '../../../components/Venster';

export function GelezenTeksten({ teksten, onBekijk, onSluit }) {
  return (
    <Venster breed={600}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2>Gelezen teksten</h2>
        <button className="btn btn-secondary" onClick={onSluit} style={{ padding: '8px 16px' }}>Sluiten</button>
      </div>

      {teksten.length === 0 ? (
        <p className="text-muted text-center">Je hebt nog geen teksten gelezen.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {teksten.map(t => (
            <div key={t.session_id} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px 16px',
              background: 'var(--vlak)',
              borderRadius: 8,
              border: '1px solid var(--lijn)',
            }}>
              <div>
                <strong>{t.text_titel}</strong>
                <div style={{ fontSize: 13, color: 'var(--tekst-3)', marginTop: 4 }}>
                  {t.completed_at && <span>Gelezen op {t.completed_at}</span>}
                  {t.mc_score !== null && (
                    <span style={{ marginLeft: 12 }}>Score: {t.mc_score}/{t.mc_total} ({t.mc_percentage}%)</span>
                  )}
                </div>
              </div>
              <button className="btn btn-primary" style={{ padding: '8px 12px', fontSize: 13 }} onClick={() => onBekijk(t.session_id)}>
                <Eye size={14} /> Bekijk
              </button>
            </div>
          ))}
        </div>
      )}
    </Venster>
  );
}
